import { FormattedMessage, useIntl } from 'react-intl';
import Checkbox from '../Checkbox';
import { useFormContext, useWatch } from 'react-hook-form';
import { OrderSendForm } from '@/types/order';
import useToggle from '@/hooks/useToggle';
import PrivacyPolicyModal from '../PrivacyPolicyModal';
import TermsOfServiceModal from '../TermsOfServiceModal';
import { Image } from '@/components/Image';

export const ServiceAgreement = () => {
  const intl = useIntl();
  const { setValue } = useFormContext<OrderSendForm>();
  const agree_check1 = useWatch({ name: 'service_agreement_1' });
  const agree_check2 = useWatch({ name: 'service_agreement_2' });

  const termsToggle = useToggle({ showing: false });
  const serviceToggle = useToggle({ showing: false });

  return (
    <>
      <div className="w-full h-4 bg-[#f5f5f5]" />

      <div className="flex flex-col gap-6 px-5 pb-10 pt-0 mt-10">
        <div className="flex flex-col gap-4">
          <span className="text-[24px] leading-8 font-bold">
            <FormattedMessage id="service-agreement" defaultMessage="Service agreement" />
          </span>
          <div className="flex flex-col gap-4 p-5 bg-[#F2F2F2] rounded-[10px]">
            <Checkbox
              checked={agree_check1}
              label={intl.formatMessage({
                id: 'order_section3_input1_label',
                defaultMessage: 'I have confirmed that cancellations and refunds are not possible after purchase is complete.'
              })}
              onClick={() => setValue('service_agreement_1', !agree_check1)}
            />
          </div>
          <div className="flex flex-col gap-2">
            <span className="text-[14px] leading-5 font-semibold  w-max">
              <FormattedMessage id="order_page_refund_information" defaultMessage="Refund Information" />
            </span>
            <span className="text-[13px] leading-[18px] font-medium text-[#808080]">
              ·{' '}
              <FormattedMessage
                id="order_section3_input1_caption"
                defaultMessage="The payment will be paid to the seller immediately. Cancelling the purchase of the photocard is not possible for any reason."
              />
            </span>
            <span className="text-[13px] leading-[18px] font-medium text-[#808080]">
              <FormattedMessage
                id="order_refund_policy"
                defaultMessage="· Refund might be possible only if the Photocard is not the quality that is assured by Pocaspot."
              />
            </span>
          </div>
          <div className="flex flex-col gap-4 p-5 bg-[#F2F2F2] rounded-[10px]">
            <Checkbox
              checked={agree_check2}
              label={intl.formatMessage({
                id: 'order_purchase_confirm',
                defaultMessage: 'I have confirmed the terms of service and privacy policy of the Pocaspot and agree to purchase.'
              })}
              onClick={() => setValue('service_agreement_2', !agree_check2)}
            />
          </div>

          <div className="flex flex-col gap-2">
            <div className="h-6 flex gap-1" onClick={termsToggle.open}>
              <span className="text-[16px] leading-6 font-semibold text-[#999999]">Terms of Service</span>
              <Image src="/icons/chevron-right-gray.svg" alt="arrow-right" className="w-5" width={20} />
            </div>
            {termsToggle.isShowing && <TermsOfServiceModal onClick={termsToggle.close} />}

            <div className="h-6 flex gap-1" onClick={serviceToggle.open}>
              <span className="text-[16px] leading-6 font-semibold text-[#999999]">Privacy Policy</span>
              <Image src="/icons/chevron-right-gray.svg" alt="arrow-right" className="w-5" width={20} />
            </div>
            {serviceToggle.isShowing && <PrivacyPolicyModal onClick={serviceToggle.close} />}
          </div>
        </div>
      </div>
    </>
  );
};
